/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_Dark_TitleInputs */

const en_wc_tour_dark_title = /** @type {(inputs: Wc_Tour_Dark_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark mode`)
};

/**
* | output |
* | --- |
* | "Dark mode" |
*
* @param {Wc_Tour_Dark_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_dark_title = /** @type {((inputs?: Wc_Tour_Dark_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_Dark_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_dark_title(inputs)
});
export { wc_tour_dark_title as "wc.tour.dark.title" }